import { map as _map } from 'lodash-es';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import MTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LinkTab from './link-tab';

export type TabOption = {
  value: string;
  label?: React.ReactNode;
  component?: React.ElementType;
  href?: string;
};

type Props = {
  options?: TabOption[];
  tab?: string;
  onTabChange?: (event: React.SyntheticEvent, value: string) => void;
  className?: string;
  links?: boolean;
};

const Tabs = (props: Props) => {
  const {
    options,
    tab,
    onTabChange,
    className,
    links = false,
    ...tabsProps
  } = props;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));

  const centered = options.length <= 2 && isSmDown;
  const TabComponent = links ? LinkTab : Tab;

  return (
    <MTabs
      value={tab}
      onChange={onTabChange}
      scrollButtons={options.length <= 2 || isMdUp ? "auto" : true}
      variant={centered ? 'standard' : 'scrollable'}
      centered={centered}
      aria-label="scrollable tabs"
      className={className}
      {...tabsProps}
    >
      {_map(options, (tab) => {
        return (
          <TabComponent
            key={tab.value}
            disableRipple
            {...tab}
          />
        );
      })}
    </MTabs>
  );
};

export default Tabs;
